import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as _ from 'underscore';

@Component({
  selector: 'info-link',
  template: `
    <span class="info-link" (click)="doInfoAction()">
      <i class="info-link-icon fa fa-info-circle"></i>
      <span class="info-link-text"><ng-content></ng-content></span>
    </span>
  `
})
export class InfoLinkComponent {
  @Input() public linkVariable: boolean;
  @Output() public linkVariableChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public linkAction: EventEmitter<void> = new EventEmitter<void>();

  public doInfoAction(): void {
    if (!_.isUndefined(this.linkVariable)) {
      this.linkVariable = !this.linkVariable;
      this.linkVariableChange.emit(this.linkVariable);
    } else {
      this.linkAction.emit();
    }
  }

}